module.exports = __webpack_public_path__ + "park.svg";